import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlanService } from 'src/app/generales/services/plan.service';
import { ToastService } from 'src/app/generales/services/toast.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-publicity',
  templateUrl: './modal-publicity.component.html',
  styleUrls: ['./modal-publicity.component.scss'],
})
export class ModalPublicityComponent implements OnInit {
  @Input() props: any;
  @Input() position: any;
  @Input() type: any;
  isReject: string;
  url: string = environment.url;
  publicityImg: string;
  descriptionReject: string;
  constructor(private planService: PlanService, private modalCtrl:ModalController, private toastService:ToastService) {}

  ngOnInit() {
    if(!this.props.action.includes('http')){
      this.props.action = `https://${this.props.action}`
    }
    console.log(this.props);
    this.publicityImg = `${this.url}/file/publicity/${this.props.file}`;
  }

  findPos(id, property) {
    const { name } = this[property].find((x) => id === x.id);
    return name;
  }

  sendInfo() {
    if (this.isReject === '1') this.descriptionReject = '';
    const data = {
      state: this.isReject,
      id: this.props.id,
      description: this.descriptionReject,
    };

    this.planService.aprovePublicity(data).subscribe(res => {
      this.modalCtrl.dismiss();
      this.toastService.show('Publicidad aprobada')
    })
  }
}
